import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@coolremote/shared';
import OnIcon from './Icons/OnIcon';
import OffIcon from './Icons/OffIcon';



const useStyles = makeStyles(() => ({
  onOffContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  onOffWrap: {
    marginBottom: '5px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const OnOff = ({ value, onChange, isDisabled, textValue}) => {
  const classes = useStyles();

  return (
    <div className={classes.onOffContainer}>
      <IconButton
        className={classes.onOffWrap}
        onClick={() => {
          onChange?.(value ? 0 : 1);
        }}
        disabled={isDisabled}
      >
        {value ? <OnIcon /> : <OffIcon />}
      </IconButton>
      <span>{textValue}</span>
    </div>
  );
};

export default OnOff;
